import { combineReducers } from 'redux';

import apiError from 'modules/global/reducers/generic.error';
import loading from 'modules/global/reducers/generic.loading';
import * as types from 'modules/interventions/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const isVisible = createReducer(false, {
  [types.OPEN_UNIQUE_VIDEO_MODAL]: () => true,
  [types.CLOSE_UNIQUE_VIDEO_MODAL]: () => false,
  [types.SEND_UNIQUE_VIDEO_SUCCESS]: () => false,
});

export default combineReducers({
  isVisible,
  isLoading: loading(types.SEND_UNIQUE_VIDEO_REQUEST),
  apiError: apiError(types.SEND_UNIQUE_VIDEO_REQUEST),
});
